import type { DocumentReclassifyStatus } from "@/api/cle-api/models/documents";
import Button from "@/components/bricks/button/Button";
import type { ActionLock } from "./utils/approvalCompleteness";

interface DocumentClassificationActionsProps {
  isPending: boolean;
  onReclassify: (decision: DocumentReclassifyStatus) => void;
  /** One lock per button: the two are not disabled by the same things. See getReclassifyLocks. */
  approve?: ActionLock;
  reject?: ActionLock;
}

const OPEN: ActionLock = { disabled: false };

/** The same reason on both buttons is one situation, not two, so it is printed once. */
const lockReasons = (locks: ActionLock[]): string[] => {
  const reasons = locks
    .filter((lock) => lock.disabled)
    .map((lock) => lock.reason)
    .filter((reason): reason is string => Boolean(reason));

  return [...new Set(reasons)];
};

export const DocumentClassificationActions = ({
  isPending,
  onReclassify,
  approve = OPEN,
  reject = OPEN,
}: DocumentClassificationActionsProps) => (
  <div className="c-card">
    <h3 className="mb-3">Omklassificer Dokument</h3>
    <div className="d-flex gap-3">
      <Button
        className="flex-grow-1 text-white"
        color="success"
        disabled={isPending || approve.disabled}
        onClick={() => onReclassify("approved")}
        type="button"
      >
        Godkend
      </Button>
      <Button
        className="flex-grow-1"
        color="danger"
        disabled={isPending || reject.disabled}
        onClick={() => onReclassify("rejected")}
        type="button"
      >
        Afvis
      </Button>
    </div>
    {lockReasons([approve, reject]).map((reason) => (
      <p className="mb-0 mt-3 text-muted small" key={reason}>
        {reason}
      </p>
    ))}
  </div>
);

export const REPORTED_EVIDENCE_LOCKED_REASON =
  "Beviset er indberettet og kan ikke ændres.";
